import React from 'react'
import { useParams } from 'react-router-dom'
import IncidentDetailContainer from './IncidentDetailContainer'

const IncidentDetailContainerWrapper = (props) => {
    const params = useParams()
    return <IncidentDetailContainer {...props} params={params} />
}

export default IncidentDetailContainerWrapper
